import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'
import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React, { ForwardedRef } from 'react'
import styled from 'styled-components'
import { BeInspiredBannerVideo } from './BeInspiredBannerVideo'
import Subtitle from 'components/Luxkit/Typography/Subtitle'

const Grid = styled.div`
  width: 100%;
  display: grid;
  gap: ${rem(20)};
  grid-template-areas:
    'title'
    'video'
    'content';
  padding: ${rem(32)} 0;

  ${mediaQueryUp.sm} {
    gap: ${rem(20)} ${rem(40)};
    padding: ${rem(60)} 0;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'title video'
      'content video';
    align-items: center;
  }
`

const Title = styled(Group)`
  grid-area: title;
`

const Content = styled(Group)`
  grid-area: content;
`

const Video = styled.div`
  grid-area: video;
`

interface Props {
  videoRef: ForwardedRef<HTMLImageElement> | null;
}

export const BeInspiredBanner = ({ videoRef }: Props) => {
  return (
    <Grid>
      <Title direction="vertical" gap={4}>
        <Caption variant="small" colour="neutral-two">BE INSPIRED</Caption>
        <Heading variant="heading2" colour="neutral-one">
          Discover the <i>world’s best</i> holidays
        </Heading>
        <Subtitle variant="subtitle2">Luxury Escapes: The World’s Best Holidays premieres on Foxtel’s LifeStyle channel every Tuesday 8:30pm AEST.</Subtitle>
      </Title>
      <Content direction="vertical" gap={12}>
        <BodyText weight="bold" variant="large" colour="neutral-two">
          Join some of Australia’s best-known faces as they travel to the world’s most sought-after destinations in a new season of the travel program, Luxury Escapes: The World’s Best Holidays.
        </BodyText>
        <BodyText variant="large" colour="neutral-two">
          Season six of the acclaimed travel show will feature up-and-coming Indonesian islands full of wild horses, the most luxurious places to stay on the Greek islands, and fast-paced city breaks in London, Dubai and New York.
        </BodyText>
      </Content>
      <Video>
        <BeInspiredBannerVideo videoRef={videoRef} />
      </Video>
    </Grid>
  )
}
